import React from "react";
import { STWrapperModal, STModal } from "./styles";

interface IProps {
  width: number;
  isOpened: boolean;
  onClose: () => void;
}

class ManageModal extends React.Component<IProps> {
  render() {
    return (
      <STModal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.props.isOpened}
        onClose={this.props.onClose}
      >
        <STWrapperModal width={this.props.width}>
          {this.props.children}
        </STWrapperModal>
      </STModal>
    );
  }
}

export default ManageModal;
